import React, { forwardRef } from "react";
import { Input, Label, Container, MessageInput } from "./styles";
import './styles.css'
import { TitleFieldForm } from "../../styles/styles";

const InputResponsive1 = forwardRef((props , ref) => {
    
  return(
    <>
      <Container width={props.width}>
        <TitleFieldForm>{props.title}<Label style={{ color: 'red', fontSize: 20 }}>{props.mandatory}</Label></TitleFieldForm> 
        <Input id="input"  defaultValue={props.defaultValue} 
               type={props.type}
               ref={ref}
               className={props.className}
               name={props.name}         
               {...props.register} 
               {...props.setValue}
               value={props.value} 
               style={props.style} 
               maxLength={props.maxlength}
               onWheel={() => document.activeElement.blur()}
               placeholder={props.placeholder} 
               disabled={props.disabled}
               required={props.required}
               onChange={props.onChange} />
        <MessageInput >{props.erro}</MessageInput>
      </Container>
  </>
  )
})

export default InputResponsive1;